import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdministrationComponent} from './administration.component';
import {
  FP_ROUTES,
  FS_ROUTES,
  HAS_ADMINISTRATION,
  HAS_GEF,
  HAS_GESTION_IDISTRI,
  HAS_GESTION_STOCKS, HAS_GESTIONPRODUITS,
  HAS_PMS,
  HAS_PORTAIL_ADMIN,
  OUTLET_SECONDARY
} from '../core/constants';
import {SitesComponent} from './sites/sites.component';
import {EnvironnementsComponent} from './environnements/environnements.component';
import {UtilisateursComponent} from './utilisateurs/utilisateurs.component';
import {Auth2Guard} from '../core/services/security/auth2.guard';
import {FicheidentiteSiteComponent} from './sites/ficheidentite-site/ficheidentite-site.component';
import {FeaturesComponent} from './features/features.component';
import {SiteResolverService} from './site-resolver.service';
import {EnvironnementResolverService} from './environnement-resolver.service';
import {FicheidentiteEnvironnementComponent} from './environnements/ficheidentite-environnement/ficheidentite-environnement.component';
import {ContratMenuService} from '../core/services/gestioncontrats/contrat-menu.service';
import {ConvivesComponent} from './convives/convives.component';
import {FamillesGemrcnComponent} from './familles-gemrcn/familles-gemrcn.component';
import {RepasComponent} from './repas/repas.component';
import {DecoupagesRepasComponent} from './decoupages-repas/decoupages-repas.component';
import {TypesProduitComponent} from './types-produit/types-produit.component';
import {FamillesProduitComponent} from './familles-produit/familles-produit.component';
import {AllergenesComponent} from './allergenes/allergenes.component';
import {FicheidentiteUtilisateurComponent} from './utilisateurs/ficheidentite-utilisateur/ficheidentite-utilisateur.component';
import {UtilisateurResolverService} from './utilisateur-resolver.service';
import {DeclinaisonsComponent} from './declinaisons/declinaisons.component';
import {UnitesDeMesuresComponent} from './unites-de-mesures/unites-de-mesures.component';
import {EquipesComponent} from './equipes/equipes.component';
import {AtelierComponent} from './ateliers/atelier.component';
import {ZonesDeStockageComponent} from './zones-de-stockage/zones-de-stockage.component';
import {SecteursComponent} from './secteurs/secteurs.component';
import {TaxesComponent} from './taxes/taxes.component';
import {AppellationsComponent} from './appellations/appellations.component';
import {ParametresComponent} from './parametres/parametres.component';
import {LitigesComponent} from './litiges/litiges.component';
import {MotifsNonConformiteComponent} from './motifs-non-conformite/motifs-non-conformite.component';
import {ProfilsComponent} from './profils/profils.component';
import {ProfilsResolverService} from './profils/profils-resolver.service';
import {RegimesAlimentairesComponent} from './regimes-alimentaires/regimes-alimentaires.component';
import {UtilisateursConnexionsComponent} from './utilisateurs-connexions/utilisateurs-connexions.component';
import {OrigineGridComponent} from "./origines/origine-grid.component";
import {GrilleStocksMouvementsStatutComponent} from "./stocks/statuts/grille-statuts/grille-statuts.component";

import {GrilleConditionnementsComponent} from './conditionnements/grille-conditionnements.component';
import {VariantesComponent} from './conditionnements/variantes/grille-variantes/variantes.component';
import {ConditionnementsVariantesComponent} from "./conditionnements/conditionnements-variantes/grille/conditionnements-variantes.component";
import {GrilleTacheComponent} from "./taches/grille-taches.component";
import {PmsUniteGrilleComponent} from "./pms/unite/grille/pms-unite-grille.component";
import {PmsSeuilGrilleComponent} from "./pms/seuil/grille/pms-seuil-grille.component";
import {PmsEquipementGrilleComponent} from "./pms/equipement/grille/pms-equipement-grille.component";
import {PmsZoneANettoyerGrilleComponent} from "./pms/zone-a-nettoyer/grille/pms-zone-a-nettoyer-grille.component";
import {PmsEquipementANettoyerGrilleComponent} from "./pms/equipement-a-nettoyer/grille/pms-equipement-a-nettoyer-grille.component";
import {PmsSignatureUtilisateurGrilleComponent} from "./pms/signature-utilisateur/grille/pms-signature-utilisateur-grille.component";
import {PmsTypeUtilisateurGrilleComponent} from "./pms/type-utilisateur/grille/pms-type-utilisateur-grille.component";
import {GridEnvironnementPlcComponent} from "./portail/environnement-plc/grid/grid-environnement-plc.component";
import {SidebarEnvironnementPlcComponent} from "./portail/environnement-plc/sidebar/sidebar-environnement-plc.component";
import {SidebarEnvironnementPlcResolverService} from "./portail/environnement-plc/sidebar/sidebar-environnement-plc-resolver.service";
import {PmsTypeTacheGrilleComponent} from "./pms/type-tache/grille/pms-type-tache-grille.component";
import {PmsTypeEquipementGrilleComponent} from "./pms/type-equipement/grille/pms-type-equipement-grille.component";
import {PmsTacheGrilleComponent} from "./pms/tache/grille/pms-tache-grille.component";
import {ConfigurationPortailPlcGridComponent} from "./portail/configuration-portail-plc-grid/configuration-portail-plc-grid.component";
import {ConfigurationPortailPlcGridResolverService} from "./portail/configuration-portail-plc-grid/configuration-portail-plc-grid-resolver.service";
import {GestionAdministrationComponent} from "./gestion-administration/gestion-administration.component";
import {TourneesComponent} from "./tournees/tournees.component";
import {FamilleEgalimComponent} from "./famille-egalim/famille-egalim.component";
import {CommunicationProduitComponent} from "./base/communication.produit/communication-produit.component";
import {ElementFacturableComponent} from "./facturation/elements-facturables/element-facturable.component";
import {LanceursFluxGefComponent} from "./gef/lanceurs-flux-gef/lanceurs-flux-gef.component";
import {ConnectionsGefConfigComponent} from "./gef/connecteurs-gef/connections-gef-config.component";
import {HistoriqueFluxGefComponent} from "./gef/historique-flux-gef/historique-flux-gef.component";
import {MonitoringGefComponent} from "./gef/monitoring-gef/monitoring-gef.component";

const routes: Routes = [{
    path: FP_ROUTES.ADM,
    component: AdministrationComponent,
    canActivate: [Auth2Guard],
    canActivateChild: [Auth2Guard],
    runGuardsAndResolvers: 'always',
    data: {
      roles: [HAS_ADMINISTRATION, HAS_PORTAIL_ADMIN],
      permission: 'OR'
    },
  },
    {
      // path: 'ficheidentite/:idSite',
      path: `${FS_ROUTES.ADM_SITE_FIC}/:idSite`,
      component: FicheidentiteSiteComponent,
      data: {
        roles: [HAS_ADMINISTRATION]
      },
      resolve: {
        siteSupplier: SiteResolverService
      },
      outlet: OUTLET_SECONDARY
    },
    {
      //  'ficheidentite/:idEnvironnement',
      path: `${FS_ROUTES.ADM_ENVIRONNEMENT_FIC}/:idEnvironnement`,
      component: FicheidentiteEnvironnementComponent,
      data: {
        roles: [HAS_ADMINISTRATION]
      },
      resolve: {
        environnementSupplier: EnvironnementResolverService
      },
      outlet: OUTLET_SECONDARY
    },
    {
      //  'sidebar-environnement-plc/:idEnvironnement',
      path: `${FS_ROUTES.ADM_ENVIRONNEMENT_PLC_FIC}/:idEnvironnementPlc`,
      component: SidebarEnvironnementPlcComponent,
      data: {
        roles: [HAS_PORTAIL_ADMIN]
      },
      resolve: {
        sidebarEnvironnementPlcSupplier: SidebarEnvironnementPlcResolverService
      },
      outlet: OUTLET_SECONDARY
    },
    {
      // path: 'ficheidentite/:idUtilisateur',
      path: `${FS_ROUTES.ADM_UTILISATEUR_FIC}/:idUtilisateur`,
      component: FicheidentiteUtilisateurComponent,
      data: {
        roles: [HAS_ADMINISTRATION]
      },
      resolve: {
        utilisateurSupplier: UtilisateurResolverService
      },
      outlet: OUTLET_SECONDARY
    },
    {
      path: 'administration/features',
      component: FeaturesComponent,
      runGuardsAndResolvers: 'always',
      canActivate: [Auth2Guard],
      canActivateChild: [Auth2Guard],
      data: {
        roles: [HAS_ADMINISTRATION, HAS_PORTAIL_ADMIN],
        permission: 'OR'
      },
      children: [
        {
          path: 'environnements',
          component: EnvironnementsComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'grid-environnement-plc',
          component: GridEnvironnementPlcComponent,
          data: {
            roles: [HAS_PORTAIL_ADMIN]
          }
        },
        {
          path: 'sites',
          component: SitesComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          },
        },
        {
          path: 'utilisateurs',
          component: UtilisateursComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },

        {
          path: 'utilisateursconnexions',
          component: UtilisateursConnexionsComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },

        {
          path: 'convives',
          component: ConvivesComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'familles-gemrcn',
          component: FamillesGemrcnComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'familles-produit',
          component: FamillesProduitComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'repas',
          component: RepasComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'origines',
          component: OrigineGridComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'decoupages-repas',
          component: DecoupagesRepasComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'types-produit',
          component: TypesProduitComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'allergenes',
          component: AllergenesComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'declinaisons',
          component: DeclinaisonsComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'unites-de-mesures',
          component: UnitesDeMesuresComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'communications-produit',
          component: CommunicationProduitComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'ateliers',
          component: AtelierComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'zones-de-stockage',
          component: ZonesDeStockageComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'equipes',
          component: EquipesComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'secteurs',
          component: SecteursComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'taxes',
          component: TaxesComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'appellations',
          component: AppellationsComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'parametres',
          component: ParametresComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'litiges',
          component: LitigesComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'motifs-non-conformite',
          component: MotifsNonConformiteComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'familles-egalim',
          component: FamilleEgalimComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'profils',
          component: ProfilsComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION]
          },
          resolve: {
            profilSupplier: ProfilsResolverService
          }
        },
        {
          path: 'regimes-alimentaires',
          component: RegimesAlimentairesComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION]
          },
        },
        {
          path: 'stocks-mouvements-statuts',
          component: GrilleStocksMouvementsStatutComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_GESTION_STOCKS],
            permission: 'AND'
          }
        },
        {
          path: 'conditionnements',
          component: GrilleConditionnementsComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_GESTION_IDISTRI],
            permission: 'AND'
          }
        },
        {
          path: 'variantes',
          component: VariantesComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_GESTION_IDISTRI],
            permission: 'AND'
          }
        },
        {
          path: 'conditionnements-variantes',
          component: ConditionnementsVariantesComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_GESTION_IDISTRI],
            permission: 'AND'
          }
        },
        {
          path: 'taches',
          component: GrilleTacheComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'unites-pms',
          component: PmsUniteGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'seuils-pms',
          component: PmsSeuilGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'equipements-pms',
          component: PmsEquipementGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'zones-pms',
          component: PmsZoneANettoyerGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'equipements-a-nettoyer-pms',
          component: PmsEquipementANettoyerGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'signatures-utilisateur-pms',
          component: PmsSignatureUtilisateurGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'types-utilisateur-pms',
          component: PmsTypeUtilisateurGrilleComponent,
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'types-tache-pms',
          component: PmsTypeTacheGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'types-equipement-pms',
          component: PmsTypeEquipementGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'taches-pms',
          component: PmsTacheGrilleComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION, HAS_PMS],
            permission: 'AND'
          }
        },
        {
          path: 'configuration-portail-plc',
          component: ConfigurationPortailPlcGridComponent,
          runGuardsAndResolvers: 'always',
          data: {
            roles: [HAS_ADMINISTRATION]
          },
          resolve: {
            configurationPortailPlcGridSupplier: ConfigurationPortailPlcGridResolverService
          }
        },
        {
          path: 'gestion-administration',
          component: GestionAdministrationComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'tournees',
          component: TourneesComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        },
        {
          path: 'elements-facturables',
          component: ElementFacturableComponent,
          data: {
            roles: [HAS_ADMINISTRATION]
          }
        }
      ]
    },
    {
      path: `${FS_ROUTES.ADM_CONFIG_GEF_CONNECTEURS}`,
      component: ConnectionsGefConfigComponent,
      data: {
        roles: [HAS_GEF]
      }
    },
    {
      path: `${FS_ROUTES.ADM_CONFIG_GEF_LANCEURS_FLUX}`,
      component: LanceursFluxGefComponent,
      data: {
        roles: [HAS_GEF]
      }
    },
    {
      path: `${FS_ROUTES.ADM_CONFIG_GEF_HISTORIQUE_FLUX}`,
      component: HistoriqueFluxGefComponent,
      data: {
        roles: [HAS_GEF]
      }
    },
    {
      path: `${FS_ROUTES.ADM_CONFIG_GEF_MONITORING}`,
      component: MonitoringGefComponent,
      data: {
        roles: [HAS_GEF]
      }
    },
  ]
;

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [SiteResolverService, EnvironnementResolverService, ContratMenuService]
})
export class AdministrationRoutingModule {
}
